import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { RolesSharedService } from '@app/feature/main/roles-shared/services/roles-shared.service';
import { ConnectService } from '@app/shared/services/connect.service';
import swal from "sweetalert2";
import { AuthenticationService } from '@app/shared/services/authentication.service';
import { Router } from '@angular/router';
import { debounceTime , distinctUntilChanged, switchMap, map} from 'rxjs/operators';
import { fromEvent } from 'rxjs/observable/fromEvent';
import { Subscription } from 'rxjs';
import { LoaderService } from '@app/shared/services/loader.service';
@Component({
  selector: 'app-connections',
  templateUrl: './connections.component.html',
  styleUrls: ['./connections.component.css']
})
export class ConnectionsComponent implements OnInit {
  @ViewChild('searchInput') searchInput : ElementRef;
  connectRequestList: any = [];
  myRejectedConnectionList: any = [];
  myConnectedConnectionList: any = [];
  myDisconnectedConnectionList: any = [];
  myRequestedConnectionList: any = [];
  receivedRequestList: any = [];
  selectedTab: any = 1;
  searchText: string = '';
  userRole: string = '';
  subscription: Subscription;

  constructor(
    private rolesSharedService: RolesSharedService,
    private connectService: ConnectService,
    private authenticationService: AuthenticationService,
    private router: Router,
    private loaderService: LoaderService
  ) { }

  ngOnInit() {
    this.callInitApis();
    this.getRole();
    fromEvent(this.searchInput.nativeElement, 'keyup').pipe(
      // get value
      map((event: any) => {
        return event.target.value;
      })
      // if character length greater then 2
      // ,filter(res => res.length > 2)
      // Time in milliseconds between key events
      ,debounceTime(1000)        
      // If previous query is diffent from current   
      ,distinctUntilChanged()
      // subscription for response
      ).subscribe((text: string) => {
        this.searchText = text;
        this.callInitApis();

      });
  }

  callInitApis() {
    const tab = this.selectedTab;
    switch (tab) {
      case 1: {
        this.getAllRequestList('connected', 1); 
         break;
      }
      case 2: {
        this.getAllRequestList('requested', 2);
         break;
      }
      case 3: {
        this.getMyConnectionsList(3);
        break;
     }
      default: {
         break;
      }
   }
  }

  getMyConnectionsList(tab) { 
    let searchKey = this.searchText;
    //received list 3
    this.selectedTab = tab;
    this.connectService.getReuestedList(this.searchText).subscribe((data: any) => {
      if (searchKey === this.searchText) {

      this.loaderService.display(false);
      this.receivedRequestList = data.data;
      }
    }, (error) => {
      swal("Info", error.error.error.message, "info");
    });
  }
  getAllRequestList(status, tab) {
    let searchKey = this.searchText;
    this.selectedTab = tab;
    this.connectService.getMyConnectionList(status, this.searchText).subscribe((data: any) => {
      if (searchKey === this.searchText) {
      this.loaderService.display(false);
      if (status === 'connected') {
        this.myConnectedConnectionList = data.data;
      }
      else {
        this.myRequestedConnectionList = data.data;
      }
    }
    }),
      (error) => {
        swal("Info", error.error.error.message, "info");
      }
  }

  search() {
    this.callInitApis();
  }

  patchChangeConnectionSatus(id, status) {
    this.connectService.updateConnectionStatus(id, status).subscribe(
      (data: any) => {
        swal("Success", data, "success");
        this.callInitApis();
      },
      error => {
        swal("Info", error.error.error.message, "info");
      });
  }
  refreshAPI() {
    this.callInitApis();
  }
  refreshSnapShotAPI() {
    this.callInitApis();
  }
  createGroup(id) {
    localStorage.setItem('userIDFromNxtPage', id);
    this.connectService.createGroup(id).subscribe(
      (resp: any) => {
        this.router.navigate([`${this.userRole}/messages`]);
      },
      (error) => {
        swal("Info", error.error.error.message, "info");
      }
    )
  }
  routeTechAnalystProfilePage(code, analystId: string) {
    if (code === 'tech_analyst') {
      this.router.navigate(['analyst-profile'], { queryParams: { analystId: analystId } });
    }
  }

  getRole() {
    this.userRole = this.authenticationService.getFormattedRole();
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/components/connections/connections.component.ts